import React from 'react';
import { Alert } from '@mui/material';
import { useAuthContext } from './AuthProvider';
import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import Layout from '../common/layout/Layout';
import AppRouter from '../routing/AppRouter';
import LoadingSpinner from './LoadingSpinner';

const AppContent: React.FC = () => {
  // Handle authentication redirects
  useMsalAuthentication(InteractionType.Redirect);

  const { isLoading, error } = useAuthContext();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  return (
    <div data-testid="app-content">
      <Layout>
        <AppRouter />
      </Layout>
    </div>
  );
};

export default AppContent;
